import React from 'react';
import { Text } from '@usealloy/component-library';
import BaseChangeContainer from './BaseChangeContainer';


interface ChangeContainerProps {
  content: string | string[];
}
export default function ChangeContainer({
  content,
}: ChangeContainerProps) {
  const contentArr = Array.isArray(content) ? content : [content];

  return (
    <BaseChangeContainer
      style={{
        borderColor: 'var(--cl-gray-400)',
      }}
    >
      <div>
        {contentArr.map(entry => (
          <Text
            key={entry}
            size={1}
            style={{
              fontFamily: 'var(--cl-font-family-mono)',
              color: 'var(--cl-grey-1100)',
              textAlign: 'left',
              lineHeight: '16px',
            }}
          >{entry}
          </Text>
        ))}
      </div>
    </BaseChangeContainer>

  );
}
